<template>
  <div id="app">
    <div id="loading">
      <img src="static/img/calendar.png" class="calendar" alt="">
      <img src="static/img/loading.gif" class="loading" alt="">
      <img src="static/img/loadingpic.png" class="pic" alt="">
      <img src="static/img/logo.png" class="logo" alt="">
      <span class="yeardate">{{yeardate}}</span>
      <span class="num">{{percent}}</span>
    </div>
    <!-- <router-view/> -->
    <keep-alive include="start,cut">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      yeardate:1921,
      percent:0,
      isOff:true,
    }
  },
  created(){
    var that = this;
    var time = setInterval(function(){
      let ram = parseInt(Math.random()*10+1);
      //console.log(this.num + 1);
      console.log(that.percent);
      that.percent += ram;
      that.yeardate += ram;
      if(that.percent>90){
        clearInterval(time);
        that.percent = 100;
        that.yeardate = 2021;
      }
    },500)
    /* document.onreadystatechange = function(){
      if(document.readyState == "complete" && this.percent > 94 ){
        clearInterval(time);
        that.percent = 100;
        that.yeardate = 2021;
        console.log('completed');
        setTimeout(function(){
           document.getElementById('loading').style.display = 'none';
        },2000);
      }
    } */
    
  },
  watch:{
    percent(val){
      if(val == 100){
        setTimeout(function(){
          if(document.querySelector("#video")){
            let video = document.querySelector("#video");
            console.log('aaaaaaaaa - ',video);
            let r = video.play();
            console.log('b2 ',r);
          }
          document.getElementById('loading').style.display = 'none';


        },1000)
      }
    }
  },
  mounted(){
    
    this.getShareInfo();
    /* document.addEventListener('touchstart',this.audioAutoPlay,false);
    document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
    let oAudio = document.querySelector("#audio");
    oAudio.onended = function () {//播放完毕，重新循环播放
      oAudio.load();
      oAudio.play();
    }
    if (window.WeixinJSBridge) {
      WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
        oAudio.play();
      }, false);
    } else {
      document.addEventListener("WeixinJSBridgeReady", function () {
        WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
          oAudio.play();
        });
      }, false);
    } */
  },
  methods:{
    audioAutoPlay() {
      let audio = document.getElementById('audio');
      this.isOff = false;
      audio.play();
      document.removeEventListener('touchstart',this.audioAutoPlay);
    },
    getShareInfo(){//如果分享的内容会根据情况变化，那么这里可以传入分享标题及url
      var wx = require('weixin-js-sdk');
      var url = 'http://wx2.ijiangyin.com/index.php?g=Wap&m=Vote_adv&a=wmjy_signinfo&token=jgwvbr1597990946&url='+encodeURIComponent(location.href);
      var pic = 'http://wx2.ijiangyin.com/h5/papercut/static/img/img.jpg';
      var tit = '剪影·百年｜红色剪纸“绘”初心';
      
      this.$axios({
        url:url,
        method:'get',
      }).then(res => {
          console.log(res.data.sign);
          var result = res.data.sign;
          //拿到后端给的这些数据
          var fxUrl = result.url;
          var appId = result.appId;
          var timestamp = result.timestamp;
          var nonceStr = result.nonceStr;
          var signature = result.signature;
          wx.config({
            debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId,         // 必填，公众号的唯一标识，填自己的！
            timestamp: timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr: nonceStr,   // 必填，生成签名的随机串
            signature: signature, // 必填，签名，见附录1
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          })
          wx.ready(function () {
            //分享到朋友圈
            wx.onMenuShareTimeline({
              title: tit,   // 分享时的标题
              link: fxUrl,     // 分享时的链接
              imgUrl: pic,    // 分享时的图标
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              }
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
              title: tit, 
              link: fxUrl,
              imgUrl: pic,
              type: '',
              dataUrl: '', 
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              }
            });
          })
        })
    }
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
p,span{
  font-family:"Microsoft YaHei"
}
#loading{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #aa0000;
  z-index: 99;
}
.calendar{
  width: 50vw;
  position: absolute;
  top: 30vw;
  left: 25vw;
}
.loading{
  width: 26vw;
  position: absolute;
  top: 90vw;
  left: 37vw;
}
#loading p{
  width: 100vw;
  text-align: center;
  color: white;
  font-size: 14px;
  position: absolute;
  top: 88vw;
}
#loading .pic{
  position: absolute;
  top: 100vw;
  width: 50vw;
  left: 25vw;
}
#loading .logo{
  position: absolute;
  bottom: 10vw;
  width: 50vw;
  left: 25vw;
}
#loading .yeardate{
  position: absolute;
  top: 44vw;
  width: 13vw;
  color: #aa0000;
  left: 34vw;
  text-align: center;
  font-size: 14px;
}
#loading .num{
  position: absolute;
  top: 59vw;
  left: 36vw;
  color: #aa0000;
  text-align: center;
  width: 18vw;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue